import axiosInstance from "../config/axios.config";
import {
  extractPrintableHtml,
  openPrintWindow,
} from "../helpers/printDocument";



export const getPharmacyPurchaseOrdersApi = (params) =>
  axiosInstance.get(`pharmacy/purchase-orders/?${params}`);

export const getPharmacyPurchaseOrderApi = (id) =>
  axiosInstance.get(`pharmacy/purchase-orders/${id}/`);

export const createPharmacyPurchaseOrderApi = (payload) =>
  axiosInstance.post("pharmacy/purchase-orders/", payload);

/** Only permitted while the order is still a draft. */
export const deletePharmacyPurchaseOrderApi = (id) =>
  axiosInstance.delete(`pharmacy/purchase-orders/${id}/`);

/** Status flag only - nothing is emailed or printed by this call. */
export const sendPharmacyPurchaseOrderApi = (id) =>
  axiosInstance.post(`pharmacy/purchase-orders/${id}/send/`);

/**
 * Refused once the order is fully received or already cancelled - a draft or a
 * completed order that has not been fully received can still be called off.
 */
export const cancelPharmacyPurchaseOrderApi = (id) =>
  axiosInstance.post(`pharmacy/purchase-orders/${id}/cancel/`);

/**
 * The whole order at once - header and lines - replacing what is on the
 * server. Takes the same payload the order was created with.
 */
export const editPharmacyPurchaseOrderApi = (id, payload) =>
  axiosInstance.put(`pharmacy/purchase-orders/${id}/edit/`, payload);

export const printPharmacyPurchaseOrder = async (id) => {
  const resp = await axiosInstance.get(
    `pharmacy/purchase-orders/${id}/?print=true`
  );
  const html = extractPrintableHtml(resp?.data);
  if (!html) {
    throw new Error(
      resp?.data?.message || "No printable purchase order was returned"
    );
  }
  openPrintWindow(html);
};


export const getPharmacyPurchaseOrderSuggestionsApi = (params) =>
  axiosInstance.get(`pharmacy/purchase-orders/suggestions/?${params}`);

/*
 * Editing one line of an order the server already holds - see the purchase
 * entry services for why a line at a time rather than the whole list.
 *
 * `totals` rides along with each call so the order's own figures stay in step
 * with its lines. A line already received, in whole or in part, cannot be
 * removed or pointed at a different medicine, and an order must keep at least
 * one line.
 */
export const addPharmacyPurchaseOrderEditItemApi = (orderId, payload) => {
  return axiosInstance.post(`pharmacy/purchase-orders/${orderId}/edit/items/`, payload);
};

export const updatePharmacyPurchaseOrderEditItemApi = (orderId, itemId, payload) => {
  return axiosInstance.patch(
    `pharmacy/purchase-orders/${orderId}/edit/items/${itemId}/`,
    payload
  );
};

export const removePharmacyPurchaseOrderEditItemApi = (orderId, itemId, payload) => {
  return axiosInstance.delete(
    `pharmacy/purchase-orders/${orderId}/edit/items/${itemId}/`,
    payload ? { data: payload } : undefined
  );
};
